import React from 'react';
import { useSelector } from 'react-redux';
import RowContainer from '../../common/CustomComponents/RowContainer';

const Careteam = () => {
  const tenantLayouts = useSelector(state => state.tenant.tenantLayout);
  return (
    tenantLayouts['Careteam'] &&
    <div className={tenantLayouts['Careteam'].className} id={tenantLayouts['Careteam'].id}>
      {tenantLayouts['Careteam'].sections.map((item, index) => {
        return <RowContainer key={index} {...item} />;
      })}
    </div>

  );
};

export default Careteam;
